import truncate from 'truncate-html';

export let handleTruncate = ($element, limit = 280) => {
	let html = $element.html();
	let text = $element.text();
	let originalHtml = html;
	let readMoreLabel = $element.data('read-more-label');
	let readLessLabel = $element.data('read-less-label');

	if(text.length > limit) {
		let readMore = `<a class="read-more read-more--more"  href="javascript:void(0)">Read More</a>`;
		let readLess = `<a class="read-more read-more--less"  href="javascript:void(0)">Read Less</a>`;
		
		const truncatedText = text.substring(0, limit) + '... ' + readMore;
		$element.html(truncatedText);

		$element.on('click', `.read-more`, (event) => {
			if($(event.currentTarget).hasClass('read-more--more')) {
				$element.html(`${originalHtml} ${readLess}`);
			}
			else {
				$element.html(truncatedText);
			}
		});
	}
};
